import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ApiService } from '@homeleite/arch';
import { timeout } from 'rxjs/operators';

interface TenantHealth {
    tenantId: string;
    enabled: boolean;
    alerts: string[];
}

interface BellItem {
    tenantId: string;
    label: string;
}

const LABELS: Record<string, string> = {
    FILA_FAILED: 'Itens da fila com erro',
    FILA_PARADA: 'Fila parada há mais de 15 min',
    BUSCA_ATIVA_ATRASADA: 'Busca ativa sem sucesso há mais de 1 h',
    BUSCA_ATIVA_COM_FALHA: 'Busca ativa com falha nas últimas 6 h',
    WEBHOOK_SEM_EVENTO_24H: 'Nenhum evento recebido há mais de 24 h',
    CONFIG_ILEGIVEL: 'Configuração da integração ilegível'
};

const POLL_MS = 120000;

@Component({
    selector: 'app-integration-alerts-bell',
    templateUrl: './integration-alerts-bell.component.html',
    styleUrls: ['./integration-alerts-bell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IntegrationAlertsBellComponent implements OnInit, OnDestroy {
    visible = false;
    state: 'loading' | 'error' | 'ready' = 'loading';
    items: BellItem[] = [];
    private timer: ReturnType<typeof setInterval> | null = null;

    constructor(private api: ApiService, private cd: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.load();
        this.timer = setInterval(() => this.load(), POLL_MS);
    }

    ngOnDestroy(): void {
        if (this.timer) clearInterval(this.timer);
    }

    load(): void {
        this.api.root
            .path('integration-sync', 'health')
            .getJson<TenantHealth[]>()
            .pipe(timeout(15000))
            .subscribe({
                next: (r) => {
                    this.items = (r || []).flatMap((t) =>
                        (t.alerts || []).map((a) => ({ tenantId: t.tenantId, label: LABELS[a] || a }))
                    );
                    this.visible = true;
                    this.state = 'ready';
                    this.cd.markForCheck();
                },
                error: (e) => {
                    if (e?.status === 403 || e?.status === 404 || e?.status === 401) {
                        this.visible = false;
                        if (this.timer) clearInterval(this.timer);
                    } else if (this.visible) {
                        this.state = 'error';
                    }
                    this.cd.markForCheck();
                }
            });
    }
}
